module.exports = __webpack_public_path__ + "static/media/land_groen.416ec6d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/land_groen.svg
// module id = 605
// module chunks = 0